let stripePublishableKeyProd: string =  "pk_live_51IYqrXFr7h7OltJthyKcAFsVWavqybQ7iViLqZkSGGHosuTI2BE0EahsC1ujIJow7qQ0pPaRFl36KUCHAqKsnRjN009LzCJ0P8";

export  {stripePublishableKeyProd};